import React from 'react';
import Icon from './Icon';

export default Icon(<path d="M 35 2.75 L 12.75 25 L 35 47.25 L 37.09375 45.15625 L 16.9375 25 L 37.09375 4.84375 L 35 2.75 z" />, null, 'BackIcon');
